import DateHelper from "./utils/DateHelper";

/**
 * RAG-29 — Un fournisseur (code COD_FOU) et la règle « PIM source » qui lui est
 * appliquée. Alimenté par GET /api/admins/supplier-pim-sources (moteur RAG-19).
 */
export class Supplier {
  public provider: string;
  public products_count: number;
  public source: string;
  public updated_at?: string;
  public updated_by?: string;

  constructor(data: any) {
    this.provider = data.provider;
    this.products_count = data.products_count ?? 0;
    this.source = data.source ?? "auto";
    this.updated_at = data.updated_at ?? undefined;
    this.updated_by = data.updated_by ?? undefined;
  }

  lastChangeLabel(): string {
    if (!this.updated_at) {
      return "—";
    }
    const date = DateHelper.dateToDDMMYYYY(new Date(this.updated_at));
    return this.updated_by ? `${date} · ${this.updated_by}` : date;
  }
}

/** Libellés lisibles des sources PIM (les valeurs viennent de l'API). */
export const SOURCE_LABELS: Record<string, string> = {
  auto: "Automatique",
  socoda: "Socoda",
  interactiv: "Interactiv",
  plateforme: "Plateforme",
  csv: "Fichier CSV",
  none: "Aucune",
};

export function sourceLabel(source: string): string {
  return SOURCE_LABELS[source] ?? source;
}
